import React from 'react';

import { statusMeta } from '../config';

/** Small pill that renders a status with the right colour. */
export default function StatusBadge({ domain = 'task', value }) {
  const meta = statusMeta(domain, value);
  return (
    <span
      className="ty-badge"
      style={{
        backgroundColor: meta.colour + '20',
        color: meta.colour,
        borderColor: meta.colour + '55',
      }}
      title={meta.label}
    >
      {meta.label}
    </span>
  );
}
